import Record from "slotworks/model/gameplay/records/record";
import { DataProcessorSupplement } from "slotworks/model/gameplay/supplements/data-processor-supplement";
import MCSpinRecord from "integration/builders/records/mc-spin-record";

class SymbolSubstituteSupplement implements DataProcessorSupplement {
    public replacements: Map<string, string> = new Map<string, string>();
    public process(record: Record) {
        if (record && record instanceof MCSpinRecord) {
            if (record.grid) {
                for (const reel of record.grid) {
                    for (let y = 0; y < reel.length; y++) {
                        if (this.replacements.has(reel[y])) {
                            reel[y] = this.replacements.get(reel[y]);
                        }
                    }
                }
            }
        }
    }
}

export default new SymbolSubstituteSupplement();
